document.addEventListener('DOMContentLoaded', async () => {
  const section = document.querySelector('[data-current-product-handle]');

  if (!section) return;

  const container = section.querySelector(
    '[data-recently-viewed-container]'
  );
  const prevButton = section.querySelector(
  '[data-recently-viewed-prev]'
);

const nextButton = section.querySelector(
  '[data-recently-viewed-next]'
);
const carousel = section.querySelector(
  '.recently-viewed-products__carousel'
);

function getScrollAmount() {
  const firstCard = container.firstElementChild;

  if (!firstCard) return 0;

  const cardWidth = firstCard.getBoundingClientRect().width;
  const styles = window.getComputedStyle(container);
  const gap = parseFloat(styles.gap) || 0;

  return cardWidth + gap;
}

function updateCarouselButtons() {
  if (!prevButton || !nextButton) return;

  const maxScroll =
    container.scrollWidth - container.clientWidth;

  prevButton.disabled =
    container.scrollLeft <= 2;

  nextButton.disabled =
    container.scrollLeft >= maxScroll - 2;
}
// function updateCarouselState() {
//   if (!carousel) return;

//   const productCount = container.children.length;

//   if (productCount > 4) {
//     carousel.classList.add('is-carousel');
//   } else {
//     carousel.classList.remove('is-carousel');
//     container.scrollLeft = 0;
//   }

//   updateCarouselButtons();
// }
function updateCarouselState() {
  if (!carousel) return;

  const productCount = container.children.length;
  const viewportWidth = window.innerWidth;

  let visibleProducts = 4;

  if (viewportWidth <= 749) {
    // Mobile always swipeable through CSS
    carousel.classList.remove('is-carousel');
    updateCarouselButtons();
    return;
  }

  if (viewportWidth <= 989) {
    visibleProducts = 2;
  }

  if (productCount > visibleProducts) {
    carousel.classList.add('is-carousel');
  } else {
    carousel.classList.remove('is-carousel');
    container.scrollLeft = 0;
  }

  updateCarouselButtons();
}

if (prevButton) {
  prevButton.addEventListener('click', () => {
    container.scrollBy({
      left: -getScrollAmount(),
      behavior: 'smooth'
    });
  });
}

if (nextButton) {
  nextButton.addEventListener('click', () => {
    container.scrollBy({
      left: getScrollAmount(),
      behavior: 'smooth'
    });
  });
}

container.addEventListener(
  'scroll',
  updateCarouselButtons,
  { passive: true }
);

window.addEventListener(
  'resize',
   updateCarouselState
);

  if (!container) return;

  const currentHandle = section.dataset.currentProductHandle;
  const productsLimit = parseInt(section.dataset.productsLimit) || 4;

  const storageKey = 'treya_recently_viewed_products';
  const maxStoredProducts = 20;

  let recentlyViewed = [];

  try {
    recentlyViewed =
      JSON.parse(localStorage.getItem(storageKey)) || [];
  } catch (error) {
    recentlyViewed = [];
  }

  const productsToDisplay = recentlyViewed
    .filter((handle) => handle !== currentHandle)
    .slice(0, productsLimit);

  if (productsToDisplay.length > 0) {
    const cardRequests = productsToDisplay.map(async (handle) => {
      try {
        const response = await fetch(
          `/products/${handle}?section_id=recently-viewed-card`
        );

        if (!response.ok) {
          console.error(
            'Recently viewed card failed to load:',
            handle
          );

          return null;
        }

        const html = await response.text();

        if (!html.trim()) {
          return null;
        }

        return html;
      } catch (error) {
        console.error(
          'Recently viewed card error:',
          handle,
          error
        );

        return null;
      }
    });

    const cards = await Promise.all(cardRequests);

    cards
      .filter(Boolean)
      .forEach((cardHtml) => {
        container.insertAdjacentHTML(
          'beforeend',
          cardHtml
        );
      });

    if (container.children.length > 0) {
      section.hidden = false;
       updateCarouselState();
    }
  }

  /*
   * Save current product after rendering
   */
  recentlyViewed = recentlyViewed.filter(
    (handle) => handle !== currentHandle
  );

  recentlyViewed.unshift(currentHandle);

  recentlyViewed = recentlyViewed.slice(
    0,
    maxStoredProducts
  );

  localStorage.setItem(
    storageKey,
    JSON.stringify(recentlyViewed)
  );
});